import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useScreen } from '../../../../hooks'
import { stopPropagation } from '../../../../utils/events'
import { ActionSelect } from '../../../Action'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { useEmailProfileContext } from '../../Email.hooks'

import {
  getActions,
  getEmailProfileMessageHeaderActions,
} from './EmailProfileMessageHeaderActions.utils'

import * as styles from './EmailProfileMessageHeaderActions.module.css'

function EmailProfileMessageHeaderActions({
  className = styles.EmailProfileMessageHeaderActions,
  data,
  disabled = false,
  getDropdownActions = getEmailProfileMessageHeaderActions,
  onClickAction,
}) {
  const { t } = useTranslation()

  const { isAppointmentAvailable, isInitiated, sub } = useEmailProfileContext()

  const { isMobileScreenSize } = useScreen()

  const actions = getActions({ permissions: data?.permissions, sub, t })

  const selectActions = getDropdownActions({
    data,
    isAppointmentAvailable,
    sub,
    t,
  })

  function getHandleClickAction(value) {
    return e => {
      stopPropagation(e)

      onClickAction({ event: e, item: data, value })
    }
  }

  return (
    <>
      <div className={className}>
        {isMobileScreenSize
          ? null
          : actions.map(({ Icon, value, ...restActionProps }) => (
              <Button.Flat
                {...restActionProps}
                isGrey
                beforeIconProps={{ Icon }}
                className={styles.action}
                disabled={disabled}
                height={BUTTON_HEIGHT_32}
                key={value}
                tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
                onClick={getHandleClickAction(value)}
              />
            ))}
        <ActionSelect
          actions={selectActions}
          disabled={disabled}
          floatingConfig={{
            placement: FLOATING_ELEMENT_PLACEMENT.bottomEnd,
          }}
          isInitiating={!isInitiated}
          onClickAction={onClickAction}
        />
      </div>
    </>
  )
}

export default EmailProfileMessageHeaderActions
